import { TableApi } from "./../../generated/api/apiPackage/table-api";
import { initAPIClient } from "./_base";

const api = initAPIClient(TableApi);

const Table = {
  get: api.venuesVenueIdBuildingsBuildingIdFacilitiesFacilityIdTablesTableIdGet,
  getAllPaginated: api.venuesVenueIdBuildingsBuildingIdFacilitiesFacilityIdTablesPaginatedGet,
  put: api.venuesVenueIdBuildingsBuildingIdFacilitiesFacilityIdTablesTableIdPut,
  delete: api.venuesVenueIdBuildingsBuildingIdFacilitiesFacilityIdTablesTableIdDelete,
  bulk: api.venuesVenueIdBuildingsBuildingIdFacilitiesFacilityIdTablesBulkInsertPost,
};

export default Table;
